import React, { useState, useEffect } from "react";
import newStyles from "../styles.module.css"; // Our CSS file
import EditCompanyCard from "./EditCompanyCard";

const CompanyViewCompany = () => {
  const [company, setCompany] = useState(null);

  useEffect(() => {
    // Retrieve the company details stored in localStorage during login
    const storedCompany = localStorage.getItem("user_data");
    if (storedCompany) {
      setCompany(JSON.parse(storedCompany));
    }
  }, []);

  return (
    <div className={newStyles.vcContainer}>
      <h1 className={newStyles.vcHeading}>Your Company</h1>
      {company ? (
        <div className={newStyles.vcGrid}>
          <EditCompanyCard
            key={company.id}
            companyName={company.companyname}
            adminName={`${company.admin_first_name} ${company.admin_last_name}`}
            adminEmail={company.adminemail}
            imageFile={company.imageFile}
            id={company.admincode} // The admincode
          />
        </div>
      ) : (
        <p>No company data available.</p>
      )}
    </div>
  );
};

export default CompanyViewCompany;
